import React from "react";
import { Chip, Stack } from "@mui/material";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import ShareRoundedIcon from "@mui/icons-material/ShareRounded";
import AffiliateSettingsCard from "../../components/dashboard/AffiliateSettingsCard";
import EditorialIntro from "../../components/dashboard/EditorialIntro";

export default function AffiliateNetworkPage() {
  return (
    <Stack spacing={{ xs: 1.75, md: 3 }} sx={{ pb: { xs: 1.5, md: 0 } }}>
      <EditorialIntro
        title="Red de referidos"
        titleVariant="h3"
        icon={<ShareRoundedIcon />}
        context="Compartí tu enlace y seguí tu red y comisiones."
        helpTitle="Dónde vive tu red"
        helpText="La red de referidos pertenece a tu cuenta de WebProfit, no a un proyecto. Por eso sigue disponible aunque todavía no hayas creado uno."
        action={
          <Chip
            icon={<AccountCircleRoundedIcon />}
            label="Sección personal"
            variant="outlined"
            sx={{ fontWeight: 900 }}
          />
        }
      />

      <AffiliateSettingsCard />
    </Stack>
  );
}
